// extracted by mini-css-extract-plugin
export default {"artist":"CreateForm_artist__lGWc9"};